import { SPARTAN_LINEUP_SECTION_ID } from '@/app/lcv/components/sections/spartan/shared/lineup/constants';

export const SPARTAN_ENGINE_SECTION_ANCHORS = {
  hero: 'hero',
  content: 'engine-content',
  specificationCompare: 'specification-compare',
  conceptVideo: 'concept-video',
  campaignBanner: 'campaign-banner',
  otherEngine: 'other-engine',
  lineup: SPARTAN_LINEUP_SECTION_ID,
} as const;

export type SpartanEngineSectionAnchor =
  (typeof SPARTAN_ENGINE_SECTION_ANCHORS)[keyof typeof SPARTAN_ENGINE_SECTION_ANCHORS];

export const SPARTAN_ENGINE_HERO_BANNER_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.hero;

export const SPARTAN_ENGINE_CONTENT_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.content;

export const SPARTAN_ENGINE_SPECIFICATION_COMPARE_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.specificationCompare;

export const SPARTAN_ENGINE_CONCEPT_VIDEO_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.conceptVideo;

export const SPARTAN_ENGINE_CAMPAIGN_BANNER_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.campaignBanner;

export const SPARTAN_ENGINE_OTHER_ENGINE_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.otherEngine;

export const SPARTAN_ENGINE_LINEUP_SECTION_ID =
  SPARTAN_ENGINE_SECTION_ANCHORS.lineup;
